import _ from 'lodash'
import { DialogSchema } from '@feedyou/schema'

import { confirm, prompt } from '../bootbox'
import { slugify } from '../transliterate/slugify'
import { Dialogs } from '../../components/steps/types'
import { generateId } from '../generateId'

// TODO: not used, maybe remove
export async function getDialog(
  dialogs: Dialogs,
  defaultName?: string
): Promise<DialogSchema | undefined> {
  const name = await prompt({
    title: 'Type in dialog name',
    message:
      'You can create the new one by typing some not yet used name (then you will be able to use the same name again to link dialog in some another place). Or you can use name of some existing dialog to link it here.\n\nAlso you can leave it empty so the new dialog will be created and you can change its name later.',
    value: defaultName
  })

  if (name === null) {
    return
  }

  if (name === '') {
    return { id: generateId.dialogId(), steps: [], exists: false }
  }

  const dialogExists = _.find(dialogs, dialog => dialog.id === name || dialog.name === name)

  if (!dialogExists) {
    return getNewDialog(name, dialogs)
  }

  if (!shouldDialogLink(name)) {
    return getDialog(dialogs, name)
  }

  return { id: dialogExists.id, name, steps: [], exists: true }
}

async function shouldDialogLink(name: string): Promise<boolean> {
  return await confirm(
    `Dialog with name "${name}" already exists, do you want to link it to this step?`
  )
}

function getNewDialog(name: string, dialogs: Dialogs) {
  const idParts = []
  const id = slugify(name)

  idParts.push(id)

  if (_.find(dialogs, dialog => dialog.id === id)) {
    idParts.push(generateId.dialogId())
  }

  return { id: idParts.join(''), name, steps: [], exists: false }
}
